// src/components/CadeteExternoModal.js
import React, { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

export const CadeteExternoModal = ({ show, onClose, handleAddExternalCadete, processing }) => {
  const [formData, setFormData] = useState({
    RE: '',
    Nome: '',
    Pelotao: '',
    Local: '',
    Turno: 'dia'
  });
  const [error, setError] = useState('');

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!formData.Nome || !formData.RE || !formData.Pelotao || !formData.Local) {
        setError("Todos os campos de Nome, RE, Pelotão e Local são obrigatórios.");
        return;
    }

    handleAddExternalCadete(formData);
    onClose();
  };

  return (
    <Modal show={show} onClose={() => !processing && onClose()} title="Cadete de Outro Pelotão (Emergência)" size="md">
        <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-yellow-800 bg-yellow-100 p-2 rounded-md font-semibold">
                **ATENÇÃO**: Esta inserção é manual, temporária e **NÃO** será salva no banco de dados. Serve apenas para incluir no PDF de escala gerado.
            </p>
            <div>
                <label className="block text-sm font-medium text-gray-700">RE</label>
                <input name="RE" value={formData.RE} onChange={handleFormChange} required className="w-full border p-2 rounded" placeholder="Ex: C-003" />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Nome (Completo)</label>
                <input name="Nome" value={formData.Nome} onChange={handleFormChange} required className="w-full border p-2 rounded" placeholder="Ex: Policial X" />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Pelotão</label>
                <input name="Pelotao" value={formData.Pelotao} onChange={handleFormChange} required className="w-full border p-2 rounded" placeholder="Ex: 4CFOA" />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Local</label>
                <input name="Local" value={formData.Local} onChange={handleFormChange} required className="w-full border p-2 rounded" placeholder="Ex: 15º BPM/M" />
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700">Turno</label>
                <select name="Turno" value={formData.Turno} onChange={handleFormChange} required className="w-full border p-2 rounded">
                    <option value="dia">dia</option>
                    <option value="noite">noite</option>
                </select>
            </div>

            {error && <p className="text-red-600 mt-2 text-sm">{error}</p>}

            <div className="flex justify-end gap-3 pt-4 border-t">
                <Button onClick={onClose} variant="secondary" disabled={processing}>
                    Cancelar
                </Button>
                <Button type="submit" variant="primary" disabled={processing}>
                    {processing ? "Inserindo..." : "Inserir Cadete Manualmente"}
                </Button>
            </div>
        </form>
    </Modal>
  );
};